import BaseModelAPI from '../BaseModelAPI';

export default class MaintenanceHistory extends BaseModelAPI {
	static entity = 'maintenancehistory';
	static entityName = 'maintenancehistory';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.workOrderExecutionnId = '';
			this.workOrderExecutionn = {};
			this.troubleReport = '';
			this.analisaDanPenyebab = '';
			this.tindakan = '';
			this.picTypeId = '';
			this.picType = {};
			this.picName = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}